import SignInAuth from './SignInAuth';

type ForgotType = {
	onForgot: (isForgot: boolean) => void;
	isForgotPassword: boolean;
};

export default function Forgot(props: ForgotType) {
	const { onForgot, isForgotPassword } = props;
	return (
		<div className="form-forgot-container">
			<SignInAuth onForgot={onForgot} displayForgot={isForgotPassword} />
		</div>
	);
}
